module.exports = __webpack_public_path__ + "static/icon_chair-f8f4c47520a68e68e5d9385cf2690b3e.svg";